var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.99992 3)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.99992 5.25C9.99496 5.24979 10.9493 5.64505 11.6528 6.34875 13.117 7.81344 13.1167 10.1878 11.652 11.6521 10.1873 13.1163 7.81292 13.1159 6.34867 11.6513 6.05582 11.3583 6.05589 10.8834 6.34883 10.5906 6.64177 10.2977 7.11664 10.2978 7.40949 10.5908 8.28804 11.4696 9.71266 11.4698 10.5915 10.5912 11.4703 9.71268 11.4705 8.28806 10.5919 7.40925 10.1699 6.98703 9.59726 6.74987 9.00024 6.75 8.58603 6.75009 8.25017 6.41438 8.25008 6.00016 8.24999 5.58595 8.58571 5.25009 8.99992 5.25Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00006-.75C11.5859-.75 14.0658.277255 15.8943 2.10575 19.7019 5.91337 19.7019 12.0867 15.8942 15.8943 12.0866 19.7019 5.91326 19.7019 2.10567 15.8942 -1.70192 12.0866-1.70188 5.91326 2.10575 2.10567 2.39865 1.81278 2.87352 1.81278 3.16641 2.10567 3.4593 2.39857 3.4593 2.87344 3.16641 3.16633 -.0554398 6.38814-.0554734 11.6117 3.16633 14.8336 6.38814 18.0554 11.6117 18.0555 14.8336 14.8336 18.0554 11.6118 18.0555 6.38823 14.8336 3.16641 13.2865 1.61921 11.1881.75 9.00006.75 8.58585.75 8.25006.414214 8.25006-1e-08 8.25006-.414214 8.58585-.75 9.00006-.75Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 2.25C12.728 2.25 15.7501 5.27208 15.7501 9 15.7501 12.7279 12.728 15.75 9.00008 15.75 5.27216 15.75 2.25008 12.7279 2.25008 9 2.25008 8.58579 2.58587 8.25 3.00008 8.25 3.41429 8.25 3.75008 8.58579 3.75008 9 3.75008 11.8995 6.10058 14.25 9.00008 14.25 11.8996 14.25 14.2501 11.8995 14.2501 9 14.2501 6.1005 11.8996 3.75 9.00008 3.75 8.58587 3.75 8.25008 3.41422 8.25008 3 8.25008 2.58579 8.58587 2.25 9.00008 2.25Z",
    stroke: "none",
    fill: "#323232"
  }))), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    stroke: "none",
    width: 24,
    height: 24,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportRings);
export default __webpack_public_path__ + "static/media/sport-rings.4015d1aa8219f1b128000f6c0e01c506.svg";
export { ForwardRef as ReactComponent };